<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} TEAM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">


           <!-- Product Image -->
           <template >
             <!-- Image Container -->
                <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img loading="lazy" v-if="ImgName" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>
             <!-- Image upload Buttons -->
             <div class="modify-img flex justify-between mt-5">
               <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
               <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
             <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">Remove Image</vs-button>
             </div>
           </template>
              <!-- Username-->
        <vs-input label="Username *" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" name="Username" v-validate="'alpha_num'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>


        <!-- FIRST NAME -->
        <vs-input label="First Name *" v-model="dataFirstName" class="mt-5 w-full" name="First Name" v-validate="'required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          <!-- Middle NAME -->

        <vs-input label="Middle Name"  v-model="dataMiddleName" class="mt-5 w-full" name="item-middle-name" maxlength="50"/>


        <!-- LAST NAME -->
        <vs-input label="Last Name *" v-model="dataLastName" class="mt-5 w-full" name="Last Name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
         <vs-input label="Nickname" v-model="dataNickName" class="mt-5 w-full" name="Nick Name" maxlength="50" />
        <vs-input label="Job Title" v-model="dataJob" class="mt-5 w-full" name="Job Title" maxlength="50" />
        <!-- PHONE -->
        <vs-input label="Phone" v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" name="Phone" maxlength="50"/>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
        <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
        <!-- ROLES -->
        <!-- EMAIL -->
        <vs-input label="Email *" @input="checkUserEmail" v-model="dataEmail" class="mt-5 w-full" name="email" v-validate="'email|required'" maxlength="150"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <span class="text-danger text-sm" v-if="emailDuplicate>0">Email has already been taken!</span>
        <br>
        <label class="vs-select--label w-full">Role *</label>
        <ul class="centerx mt-2  flex flex-wrap">
          <li class="ml-1" v-for="role in rolesList" :key="role.id">
            <vs-radio v-model="dataRole" @change="userRole =  role.name ; dataLocation=[] ; dataProgram=[]" :vs-value="role.id">{{ role.name }}</vs-radio>
          </li>
        </ul>
         <br>
          <span v-if="userRole==='manager'">
          <label class="vs-select--label">Locations</label><br><br>
          <vs-checkbox v-for="location in locations" :key="location.id" :vs-value="location.id" v-model="dataLocation">
          {{ location.name }}
        </vs-checkbox>
          <br>
        </span>
        <span v-if="userRole==='teacher'">
         <label class="vs-select--label w-full">Select Location *</label>
        <!-- <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in locations" :key="location.id">
         <vs-radio v-model="dataLocation" @change="getLocation(location.id)" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul>--><br> 
        <v-select  label="name" v-on:input="selectLocation" :closeOnSelect="true" v-model="dataLocation"  :options="locations"  /><br>
        <label class="vs-select--label w-full">Select Program *</label>
        <v-select  label="name" multiple  :closeOnSelect="true" v-model="dataProgram"  :options="programs"  /><br>
        </span>
        <!-- Send Invite Email -->
        <vs-checkbox v-show="enableInvitOption" v-model="dataEmailInviteOption"
                     @change="changeEmailConfirmationStatus(dataEmailInviteOption)">Send Invite Email
        </vs-checkbox>

<br>
        <div v-if="!dataEmailInviteOption">
          <label class="vs-select--label text-xs">Password *</label>
          <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="dataPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border"
                  />
                </vx-input-group >
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                <br>
         <label class="vs-select--label text-xs">Confirm Password *</label>
          <vs-input
            type="password"
            v-validate="'min:6|max:20|confirmed:password'"
            data-vv-validate-on="blur"
            data-vv-as="password"
            name="confirm_password"
            placeholder="Confirm Password"
            v-model="dataConfPassword"
            class="w-full" />
          <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>


<!--        <vs-row vs-w="12" class="ml-6">-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="2">-->
<!--            <label>Email Confirmed</label>-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="8">-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">-->
<!--            <vs-switch v-model="isEmailConfirmed" @change="changeInviteEmailStatus(isEmailConfirmed)"></vs-switch>-->
<!--          </vs-col>-->
<!--        </vs-row>-->
        <br>
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>


      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import {
  ADMIN_ROLES_LIST,
  CHECK_USER_EMAIL,
  CHECK_USER_NAME_EXCEPT_ID,
  SINGLE_USER_BY_EMAIL,
  SINGLE_USER_BY_USERNAME,
  UPLOAD_IMAGE,
  GET_PROGRAM_BY_LOCATION,
  ALL_LOCATIONS,
  CREATE_MANAGER,
  UPDATE_MANAGER,
  CREATE_TEACHER,
  UPDATE_TEACHER,
  CREATE_ADMIN,
  UPDATE_ADMIN,
  CENTER_ROLES_LIST,
  CREATE_USER_ACTIVITY
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/TeamImage',
}
const S3Client = new S3(config)

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true

    },
    data: {
      type: Object,
      default: () => {}
    }

  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      userRole:null,
      ImgName:'',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      rolesList: [],
      dataRole: [],
      locations:[],
      programs:[],
      emailDuplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      enableInvitOption:true,
      dataId: null,
      dataUserName: '',
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataNickName:'',
      dataImg:'',
      dataImgUrl:'',
      dataEmail: '',
      dataPhone: '',
      dataStudent: '',
      dataStatus: false,
      dataPassword: '',
      dataConfPassword: '',
      dataEmailInviteOption:true,
      isEmailConfirmed: false,
      dataLocation:[],
      dataProgram:[],
      dataJob:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      showPassword:false
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const { id, username, fname, lname, middle_name, status, email, phone, avatar, email_confirmed, roles, job_title,nick_name ,locations,programs,managerlocations} = JSON.parse(JSON.stringify(this.data))
        this.userRole = roles[0].name
        // this.dataRole = roles.map(function (value, index) {
        //   return value.id
        // })
        this.dataRole = roles[0].id
        this.dataId = id
        this.dataUserName = username
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataNickName=nick_name
        this.dataJob = job_title
        this.dataImg = this.img_cdn + avatar
        this.ImgName = avatar
        this.dataEmail = email
        this.dataPhone = phone
        if (!this.dataPhone) {
          this.dataPhone = ''
        }
       if(this.userRole==='teacher'){
        this.getLocation(locations[0].id)
        this.dataLocation = locations[0]
        this.dataProgram = programs
       }
       else if(this.userRole==='manager'){
            this.dataLocation = managerlocations.map(function (value, index) {
            return value.id
          })
       }
       else{
            this.dataLocation = locations.map(function (value, index) {
            return value.id
          })
       }

        this.dataStatus = status
        this.isEmailConfirmed = email_confirmed
        this.dataPassword = ''
        this.dataConfPassword = ''
        this.enableInvitOption = false
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
       if(this.userRole){ 
      if (this.dataEmailInviteOption && this.dataId == null) {
         if(this.userRole==='manager'){
           return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataLocation.length > 0
           }
         else if(this.userRole==='teacher'){
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataProgram.length > 0 && this.dataLocation
         }
         else{
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) 
         }
      }
      if (!this.dataEmailInviteOption && this.dataId == null) {
        if(this.userRole==='manager'){
           return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.dataConfPassword &&  this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataLocation.length > 0
           }
         else if(this.userRole==='teacher'){
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.dataConfPassword && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataProgram.length > 0 && this.dataLocation
         }
         else{
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.dataConfPassword && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) 
         }
      }
      if (this.dataEmailInviteOption && this.dataId) {
          if(this.userRole==='manager'){
           return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataLocation.length > 0
           }
         else if(this.userRole==='teacher'){
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.dataProgram.length > 0 && this.dataLocation
         }
         else{
            return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail  && this.emailDuplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0  && this.dataRole.length != 0 && (this.dataPhone == '' || this.dataPhone.length == 14) 
         }      
      }

       }
       else{
          return false
       }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    changeEmailConfirmationStatus (val) {
      this.isEmailConfirmed = !val
      this.dataPassword = ''
      this.dataConfPassword = ''
    },
    changeInviteEmailStatus (val) {
      this.dataEmailInviteOption = !val
    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Team',
        text: 'Team Added Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusFail () {
      this.$vs.notify({
        title: 'Team',
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    UpdateSuccess () {
     this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Team',
        text: 'Team Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail () {
      this.$vs.notify({
        title: 'Team',
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
    },
    checkUserName () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkUserNameExcepteId()
      } else {
        this.checkUserNameWithoutId()
      }
    },
    checkUserNameExcepteId () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else if (this.dataUserName) {
        this.$apollo
          .mutate({
            mutation: CHECK_USER_NAME_EXCEPT_ID,
            variables: {
              id: this.dataId,
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.checkUserNameExceptId.length
          })
      }
    },
    checkUserNameWithoutId () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else if (this.dataUserName) {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
    },

    checkUserEmail () {
      if(this.dataEmail.length == 0) return
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId()
      } else {
        this.checkEmailWithoutId()
      }
    },

    checkEmailExceptId () {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail
          }
        })
        .then(response => {
          this.emailDuplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.emailDuplicate = response.data.userByEmail.length
        })
    },

    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    selectLocation(event){
      if(event){
      this.getLocation(event.id)
      }
      else{
         this.dataProgram = []
      }
    },
     getLocation (location) {
      this.dataProgram = []
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_BY_LOCATION,
          variables: {
            location_id:location
          }
        })
        .then(response => {
          if (response) {
            this.programs = response.data.location_programs
          }
        }).catch(error => {
          console.log(error)
        })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataUserName = ''
      this.dataMiddleName = ''
      this.dataNickName =''
      this.dataImg = null
      this.ImgName = null
      this.dataStudent = ''
      this.dataStatus = false
      this.isEmailConfirmed = false
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataRole = []
      this.dataPassword = ''
      this.dataConfPassword = ''
      this.dataJob = null
      this.userRole = null
      this.dataLocation = []
      this.dataProgram = '',
      this.dataEmailInviteOption = true

    },
    submitData () {
      if(this.userRole==='manager'){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_MANAGER,
                variables: {
                  id: this.dataId,
                  avatar: this.ImgName,
                  fname: this.dataFirstName,
                  lname: this.dataLastName,
                  middle_name: this.dataMiddleName,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  job: this.dataJob,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  status: this.dataStatus,
                  locations: this.dataLocation,
                  roles:this.dataRole
                }
              }).then(response => {
                if (response.data.updateManager.status === 'SUCCESS') {
                  this.teamActivity(this.dataId,"updated")
                  this.UpdateSuccess()
                }
              }).catch(error => {
                console.log(error)
                this.UpdateFail()
              })
          } else {

            this.$apollo
              .mutate({
                mutation: CREATE_MANAGER,
                variables: {
                  avatar: this.ImgName,
                  fname: this.dataFirstName,
                  lname: this.dataLastName,
                  middle_name: this.dataMiddleName,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  job: this.dataJob,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  status: this.dataStatus,
                  email_confirmed:true,
                  locations: this.dataLocation,
                  invite_email :this.enableInvitOption,
                  password: this.dataPassword,
                  roles:this.dataRole
                }
              }).then(response => {
                if (response.data.createManager.status === 'SUCCESS') {
                  this.teamActivity(response.data.createManager.user.id,"added")
                  this.StatusSuccess();
                }
              }).catch(error => {
                console.log(error)
                this.StatusFail()
              })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })

      }
      else if(this.userRole==='teacher'){
          const getlocationids = []
      getlocationids.push(this.dataLocation.id)
      const getprogramids = []
      for (let index = 0; index < this.dataProgram.length; index++) {
        getprogramids.push(this.dataProgram[index].id)
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_TEACHER,
                variables: {
                  id: this.dataId,
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  nick_name: this.dataNickName,
                  job:this.dataJob,
                  phone: this.dataPhone,
                  locations: getlocationids,
                  programs:getprogramids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  avatar: this.ImgName,
                  roles:this.dataRole
                }
              })
              .then(response => {
                if (response.data.updateTeacher.status == 'SUCCESS') {
                  this.teamActivity(this.dataId,"updated")
                  this.UpdateSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()

                }
              }).catch(error => {
                console.log(error)
                this.UpdateFail()
              })

          } else {
            // if (this.enableInvitOption) {
            //     this.dataUserName = 'User'
            // }
            this.$apollo
              .mutate({
                mutation: CREATE_TEACHER,
                variables: {
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  nick_name: this.dataNickName,
                  phone: this.dataPhone,
                  job:this.dataJob,
                  locations: getlocationids,
                  programs:getprogramids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  invite_email: this.enableInvitOption,
                  avatar: this.ImgName,
                  password: this.dataPassword,
                  roles:this.dataRole
                }
              })
              .then(response => {
                if (response.data.createTeacher.status === 'SUCCESS') {
                  this.teamActivity(response.data.createTeacher.user.id,"added")
                  this.StatusSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()
                }
              }).catch(error => {
                this.StatusFail()
                console.log(error)
              })
          }

        }
      })
      }
      else{
        this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_ADMIN,
                variables: {
                  id: this.dataId,
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  email: this.dataEmail,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  status: this.dataStatus,
                  avatar:this.ImgName,
                  roles: this.dataRole,
                  job:this.dataJob

                }
              })
              .then(response => {
                if (response) {
                  if (response.data.updateAdmin.status === 'SUCCESS') {
                  this.teamActivity(this.dataId,"updated")
                  this.UpdateSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()
                }
                }
              }).catch(error => {
                console.log(error)
              })

          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_ADMIN,
                variables: {
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  nick_name: this.dataNickName,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  email_confirmed: true,
                  status: this.dataStatus,
                  avatar:this.ImgName,
                  job:this.dataJob,
                  invite_email: this.dataEmailInviteOption,
                  roles: this.dataRole,
                  password: this.dataPassword

                }
              })
              .then(response => {
                if (response) {
                  if (response.data.createAdmin.status === 'SUCCESS') {
                  this.teamActivity(response.data.createAdmin.user.id,"added")
                  this.StatusSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()
                }
                }
              }).catch(error => {
                this.StatusFail()
                console.log(error)
              })
          }
        }
      })
      }

    },
    updateCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.ImgName = response.key
              this.dataImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
    // updateCurrImg (input) {
    //   if (input.target.files && input.target.files[0]) {
    //     this.checkImg = 'somthing'
    //     const reader = new FileReader()
    //     reader.onload = e => {
    //       this.dataImg = e.target.result
    //       this.openLoadingInDiv()
    //       this.$apollo
    //         .mutate({
    //           mutation: UPLOAD_IMAGE,
    //           variables: {
    //             image:this.dataImg,
    //             oldimage:this.oldimage
    //           }
    //         })
    //         .then(response => {
    //           if (response) {
    //             this.oldimage = ''
    //             if (response.data.uploadImage.status === 'SUCCESS') {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             } else {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.UploadFail(response.data.uploadImage.error)
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             }

    //           }
    //         }).catch(error => {
    //           console.log(error)
    //         })
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //   }
    // }
  teamActivity (id,action) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\Team',
            activity:action
          }
        })
    },
  },
  created () {
     let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
    if(userRole==='center'){
      this.$apollo
      .mutate({
        mutation: CENTER_ROLES_LIST
      })
      .then(response => {
        this.rolesList = response.data.getCenterRolesList

      })
    }else{
    this.$apollo
      .mutate({
        mutation: ADMIN_ROLES_LIST
      })
      .then(response => {
        this.rolesList = response.data.getAdminRolesList

      })
    }

      this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS
      })
      .then(response => {
        this.locations = response.data.locations
      })


  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
